import React, { useEffect, useState } from 'react';
import '../../App.css';
import logo from '../images/LM_C_HillerodFrimenighed_rgb.png';

const LoadingScreen = ({ visible = true }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [rendered, setRendered] = useState(true);

  useEffect(() => {
    if (!visible) {
      setFadeOut(true);
      const timeout = setTimeout(() => setRendered(false), 500); // match fade duration
      return () => clearTimeout(timeout);
    } else {
      setFadeOut(false);
      setRendered(true);
    }
  }, [visible]);

  if (!rendered) return null;

  return (
    <div
      className={`loading-screen ${fadeOut ? 'fade-out' : ''}`}
      style={styles.container}
    >
      <img src={logo} alt="Luthersk Mission Logo" className="pulsating-logo" />
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    zIndex: 100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100vh',
    backgroundColor: 'white',
    textAlign: 'center',
  },
};

export default LoadingScreen;
